//@flow
import { combineReducers } from 'redux'

import articleStore from './articleStore'
import blacklistStore from './blacklistStore'

export default combineReducers({
  articleStore,
  blacklistStore,
})



// WEBPACK FOOTER //
// ./src/stores/automation/index.js